/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Key = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M8.5 1C12.6421 1 16 4.35786 16 8.5C16 9.53285 15.7912 10.5169 15.4136 11.4124L23 19V23H19L17 21H14L13.999 17.999L11.4134 15.4131C10.5177 15.7911 9.53324 16 8.5 16C4.35786 16 1 12.6421 1 8.5C1 4.35786 4.35786 1 8.5 1ZM8.5 2.5C5.18629 2.5 2.5 5.18629 2.5 8.5C2.5 11.8137 5.18629 14.5 8.5 14.5C9.31256 14.5 10.1 14.3392 10.8302 14.0311L11.7603 13.6387L15.4988 17.3775L15.499 19.499L17.6213 19.5L19.62 21.499H21.499V19.62L13.6393 11.7593L14.0315 10.8294C14.3393 10.0995 14.5 9.31227 14.5 8.5C14.5 5.18629 11.8137 2.5 8.5 2.5ZM6 5C6.55228 5 7 5.44772 7 6C7 6.55228 6.55228 7 6 7C5.44772 7 5 6.55228 5 6C5 5.44772 5.44772 5 6 5Z"
                        fill={color}
                    />
                </svg>
        );
    };
